(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-onsite-loader"] && !Shopify.designMode) return;
  try {
    window._klOnsite ||= [];

  if (!window.klaviyo) {
    try {
      window.klaviyo = new Proxy(
        {},
        {
          get(_target, property) {
            if (property === 'push') {
              return (...args) => window._klOnsite.push(...args);
            }

            return (...args) => {
              const callback = typeof args.at(-1) === 'function' ? args.pop() : undefined;

              return new Promise((resolve) => {
                window._klOnsite.push([
                  property,
                  ...args,
                  (result) => {
                    callback?.(result);
                    resolve(result);
                  },
                ]);
              });
            };
          },
        },
      );
    } catch (_error) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = (...args) => window._klOnsite.push(...args);
    }
  }

  const klaviyoSource = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RHrSNq';
  const privacyApiRetryDelays = [0, 10, 25, 50, 100, 250, 500, 1000];
  const loaderState = {
    isConsentCheckRunning: false,
    isLoadScheduled: false,
  };
  const isMarketingConsentAllowed = () =>
    window.Shopify?.customerPrivacy?.currentVisitorConsent().marketing === 'yes';

  const loadKlaviyo = () => {
    if (!isMarketingConsentAllowed()) {
      loaderState.isLoadScheduled = false;
      return;
    }

    if (document.querySelector('[data-klaviyo-onsite]')) return;

    const script = document.createElement('script');
    script.src = klaviyoSource;
    script.async = true;
    script.type = 'text/javascript';
    script.dataset.klaviyoOnsite = 'true';
    document.head.appendChild(script);
  };

  const scheduleKlaviyoLoad = () => {
    if (loaderState.isLoadScheduled) return;

    loaderState.isLoadScheduled = true;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadKlaviyo, { timeout: 2500 });
      return;
    }

    window.setTimeout(loadKlaviyo, 1500);
  };

  const waitForMarketingConsent = (attempt = 0) => {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (customerPrivacy) {
      loaderState.isConsentCheckRunning = false;

      if (isMarketingConsentAllowed()) {
        scheduleKlaviyoLoad();
      }

      return;
    }

    const retryDelay = privacyApiRetryDelays[attempt];

    if (retryDelay === undefined) {
      loaderState.isConsentCheckRunning = false;
      return;
    }

    window.setTimeout(() => waitForMarketingConsent(attempt + 1), retryDelay);
  };

  const loadKlaviyoWithConsent = () => {
    if (document.readyState !== 'complete' || loaderState.isConsentCheckRunning) return;

    loaderState.isConsentCheckRunning = true;
    waitForMarketingConsent();
  };

  document.addEventListener('visitorConsentCollected', loadKlaviyoWithConsent);

  if (document.readyState === 'complete') {
    loadKlaviyoWithConsent();
  } else {
    window.addEventListener('load', loadKlaviyoWithConsent, { once: true });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shopmy-affiliate-loader"] && !Shopify.designMode) return;
  try {
    const shopMySource = 'https://static.shopmy.us/Affiliates/sms_aff_clicktrack.js';

  const loadShopMyAffiliate = () => {
    if (document.querySelector('[data-shopmy-affiliate-script]')) return;

    const script = document.createElement('script');
    script.src = shopMySource;
    script.async = true;
    script.dataset.shopmyAffiliateScript = 'true';
    document.head.appendChild(script);
  };

  const scheduleShopMyAffiliateLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadShopMyAffiliate, { timeout: 2500 });
      return;
    }

    window.setTimeout(loadShopMyAffiliate, 1500);
  };

  if (document.readyState === 'complete') {
    scheduleShopMyAffiliateLoad();
  } else {
    window.addEventListener('load', scheduleShopMyAffiliateLoad, { once: true });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stamped-widget-loader"] && !Shopify.designMode) return;
  try {
    const stampedSource = 'https://cdn1.stamped.io/files/widget.min.js';
  const stampedConfig = {
    apiKey: 'pubkey-GSrB42pjHR5pDvs39g6871uSujRR87',
    sId: '159028',
  };

  const reportStampedError = (message, error) => {
    console.warn(`[Stamped] ${message}`, error);
  };

  const initStamped = () => {
    if (window.__fabulaStampedInitialized) return true;

    try {
      if (typeof window.StampedFn?.init !== 'function') return false;

      window.StampedFn.init(stampedConfig);
      window.__fabulaStampedInitialized = true;
      return true;
    } catch (error) {
      reportStampedError('Widget initialization failed.', error);
      return false;
    }
  };

  const loadStamped = () => {
    try {
      const existingScript = document.querySelector('[data-stamped-widget]');

      if (existingScript) {
        if (!initStamped()) {
          existingScript.addEventListener('load', initStamped, { once: true });
        }
        return;
      }

      const script = document.createElement('script');
      script.src = stampedSource;
      script.async = true;
      script.type = 'text/javascript';
      script.crossOrigin = 'anonymous';
      script.dataset.stampedWidget = 'true';
      script.addEventListener('load', initStamped, { once: true });
      script.addEventListener(
        'error',
        () => {
          script.remove();
          reportStampedError('Widget script failed to load.', stampedSource);
        },
        { once: true }
      );
      document.head.appendChild(script);
    } catch (error) {
      reportStampedError('Widget script could not be added to the page.', error);
    }
  };

  const scheduleStampedLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadStamped, { timeout: 2500 });
      return;
    }

    window.setTimeout(loadStamped, 1500);
  };

  if (document.readyState === 'complete') {
    scheduleStampedLoad();
  } else {
    window.addEventListener('load', scheduleStampedLoad, { once: true });
  }
  } catch(e) { console.error(e); }
})();

})();
